function AdminDrivesViewReportCardController(session) {
  const vm = this;
  vm.driveSession = session;
  vm.reportcard = vm.driveSession.reportcard;
}
AdminDrivesViewReportCardController.$inject = ["session"];
export default AdminDrivesViewReportCardController;
